import * as React from 'react'

function SvgHome(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.334 2.138h0a.463.463 0 00-.335-.139.463.463 0 00-.334.139h0l-6.52 6.52h-.001l-.007.008h0a.475.475 0 000 .667h0a.464.464 0 00.314.138l.027.001h1.236v5.803c0 .398.325.724.724.724H6.46v-3.234c0-.986.8-1.787 1.786-1.787h1.506c.986 0 1.787.8 1.787 1.787v3.234h2.022a.726.726 0 00.724-.724V9.472h1.241a.475.475 0 00.335-.807s0 0 0 0h0M9.334 2.138l6.527 6.527M9.334 2.138l6.526 6.526h0M9.334 2.138l6.526 6.526m.001 0s0 0 0 0m0 0h0m0 0h0m0 0s0 0 0 0m0 0h0m0 0s0 0 0 0m0 0s0 0 0 0m0 0h0m0 0s0 0 0 0h0zm0 0s0 0 0 0h0zm0 0h0m0 0h0m0 0h0m0 0h0m-13.713-.01l-.001.001h0z"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  )
}

export default SvgHome
